import { TUserParamsType } from "@/features/organizations/types";
import { useQueryParams } from "@/hooks/general/useQueryParams";
import useGetUsers from "../organization/useGetUsers";
import { useGetRoles } from "../acl/useGetRoles";

const useGetItAdmins = () => {
  const { data: roles, isFetching: isFetchingRoles } = useGetRoles();
  const itAdminRole = roles?.find((item) => item.name === "IT_ADMIN");
  const { params, setParams } = useQueryParams<
    TUserParamsType & { tab?: string }
  >({
    page: 1,
    limit: 25,
    roleIds: [itAdminRole?.id ?? ""],
    orderDirection: "DESC",
  });

  const { data, isFetching } = useGetUsers(params, {
    enabled: !!itAdminRole,
  });

  return { data: data?.data, isFetching, params, setParams, isFetchingRoles };
};

export default useGetItAdmins;
